
import { defineComponent} from 'vue'
import { MutationTypes, useStore } from '@/store'
import LayoutFooter from '../components/layout/Footer.vue'
export default defineComponent({
  components: {
    LayoutFooter
  },
  setup() {
    const store = useStore()
    const showLoginModal = () => {
      store.commit(MutationTypes.SET_LOGIN_MODAL_STATE, true)
    }
    return {
      showLoginModal
    }
  },
})
